<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <!-- <el-collapse v-model="collapseActiveName" accordion>
        <el-collapse-item name="1"> -->
          <!-- <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批123</el-badge>
          </template> -->
          <div>
            <el-tabs v-model="freeCodeActiveName" type="card">
              <el-tab-pane label="待我审批" name="freeCodePendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="freeCodePendingApprovalTableHead" :tableData="freeCodePendingApprovalTableData" :operationArr="freeCodePendingApprovalOperationArr" @electricApproveRow="freeCodeApproveRow" @electricUnApproveRow="freeCodeUnApproveRow" :total="freeCodePendingApprovalTotal" :pageNum="freeCodePendingApprovalPageNum" :pageSize="freeCodePendingApprovalPageSize" @changePagination="changeFreeCodePendingApprovalPagination" @seeExample="seeExample"/>
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="freeCodeApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="freeCodeApprovedTableHead" :tableData="freeCodeApprovedTableData" :operationArr="freeCodeApprovedOperationArr" :total="freeCodeApprovedTotal" :pageNum="freeCodeApprovedPageNum" :pageSize="freeCodeApprovedPageSize" :hasOperation="false" @changePagination="changeFreeCodeApprovedPagination" @seeExample="seeExample"/>
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="freeCodeSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="freeCodeSponsoredTableHead" @recall="recall" :tableData="freeCodeSponsoredTableData" :operationArr="freeCodeSponsoredOperationArr" :total="freeCodeSponsoredTotal" :pageNum="freeCodeSponsoredPageNum" :pageSize="freeCodeSponsoredPageSize" @changePagination="changeFreeCodeSponsoredPagination" @seeExample="seeExample"/>
              </el-tab-pane>
            </el-tabs>
          </div>
        <!-- </el-collapse-item>
      </el-collapse> -->
    </div>

    <!--免费码审批通过-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveFreeCodeDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="applyResult" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelFreeCodeApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passFreeCodeSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--免费码审批驳回-->
    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveFreeCodeRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="applyResult" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelFreeCodeReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassFreeCodeSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

      <el-dialog title="审批进度" :visible.sync="flowDialog" style="margin-top:200px" >
        <el-steps :active="currentRate" align-center finish-status="success">
          <el-step :title="applyData.status=='4'?applyData.sponsorAccountName+'已撤回':applyData.sponsorAccountName+'发起审批'" :description="applyData.applyDate"></el-step>
          <el-step v-if="applyData.status!='4'" v-for="(item, index) in flowData" :key="item.code" :title="item.statusText" :description="item.approveDate" :status="item.status&&item.status!='0'?item.status=='2' ? 'error' : 'success':''"></el-step>
        </el-steps>
      </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import { api } from "../../api/WorkbenchApproval";

export default {
  components: {
    TableMain,
    Breadcrumb,
  },
  name: "workbench-approval",
  data() {
    return {
      yqCode: "",
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval",
        },
        {
          value: "免费码授权人审批",
        },
      ],
      collapseActiveName: "",
      freeCodeItemTitle: "免费码授权人审批",
      accountCode: "",
      activeName: "pendingApproval",
      freeCodeActiveName: "freeCodePendingApproval",

      // 投诉建议
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名",
        },
        {
          prop: "personPhone",
          label: "手机号",
        },
        {
          prop: "roomNumber",
          label: "房间号",
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
        },
        {
          prop: "type",
          label: "类型",
        },
        {
          prop: "createTime",
          label: "提交时间",
        },
        {
          prop: "statusText",
          label: "状态",
        },
      ],
      operationArr: ["modifySuggestions"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: "",
        searchKey: "",
        result: "",
        status: "0",
      },
      applyResult:'',

      freeCodeApproveData: {},
      freeCodeUnApproveData: {},
      approveFreeCodeDialog: false,
      approveFreeCodeRejectDialog: false,
      freeCodeMemo: "",

      // 我发起的(免费码)
      freeCodeSponsoredTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "name",
          label: "申请人",
        },
        {
          prop: "phone",
          label: "联系电话",
        },
        {
          prop: "enterpriseName",
          label: "企业名称",
        },
        {
          prop: "memo",
          label: "备注",
        },
        {
          prop: "statusText",
          label: "状态",
          showColor: true,
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
        // {
        //   prop: "approveAccountName",
        //   label: "处理人",
        // },
      ],
      freeCodeSponsoredTableData: [],
      freeCodeSponsoredOperationArr: ["recall"],
      freeCodeSponsoredTotal: 0,
      freeCodeSponsoredPageNum: 1,
      freeCodeSponsoredPageSize: 10,

      // 待我审批(免费码)
      freeCodePendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "name",
          label: "申请人",
        },
        {
          prop: "phone",
          label: "联系电话",
        },
        {
          prop: "enterpriseName",
          label: "企业名称",
        },
        {
          prop: "memo",
          label: "备注",
        },
        {
          prop: "applyDate",
          label: "申请时间",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      freeCodePendingApprovalTableData: [],
      freeCodePendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      freeCodePendingApprovalTotal: 0,
      freeCodePendingApprovalPageNum: 1,
      freeCodePendingApprovalPageSize: 10,

      // 我已审批(免费码)
      freeCodeApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "name",
          label: "申请人",
        },
        {
          prop: "phone",
          label: "联系电话",
        },
        {
          prop: "enterpriseName",
          label: "企业名称",
        },
        {
          prop: "applyDate",
          label: "申请时间",
        },
        {
          prop: "memo",
          label: "备注",
        },
        {
          prop: "statusText",
          label: "状态",
          showColor: true,
        },
        {
          prop: "applyResult",
          label: "审批意见",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      freeCodeApprovedTableData: [],
      freeCodeApprovedOperationArr: ["details"],
      freeCodeApprovedTotal: 0,
      freeCodeApprovedPageNum: 1,
      freeCodeApprovedPageSize: 10,

      flowDialog:false,
      applyData:{},
      chainList:[],
      flowData:{},
      currentRate:0
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.requestData.responsiblePersonCode = bus.global.accountCode;
    this.accountCode = bus.global.accountCode;
    this.getPageByFreeCodePendingApprovalPage();
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType;
    }
  },
  methods: {
    // 跳转审批详情页面
    toDetailsPage(data) {
      sessionStorage.setItem("workDetailData", JSON.stringify(data));
      sessionStorage.setItem("workDetailActiveName", this.activeName);
      if (data.type === "其他合同") {
        this.$router.push({
          name: "other-approval-detail",
        });
      } else {
        this.$router.push({
          name: "approval-detail",
        });
      }
    },
    // 我发起的页码跳转(免费码)
    changeFreeCodeSponsoredPagination(data) {
      this.freeCodeSponsoredPageNum = data[0];
      this.freeCodeSponsoredPageSize = data[1];
      this.getPageByFreeCodeSponsorAccountCode();
    },

    // 待我审批页码跳转(免费码)
    changeFreeCodePendingApprovalPagination(data) {
      this.freeCodePendingApprovalPageNum = data[0];
      this.freeCodePendingApprovalPageSize = data[1];
      this.getPageByFreeCodePendingApprovalPage();
    },

    // 我已审批页码跳转(免费码)
    changeFreeCodeApprovedPagination(data) {
      this.freeCodeApprovedPageNum = data[0];
      this.freeCodeApprovedPageSize = data[1];
      this.getPageByFreeCodeApprovedPage();
    },

    // 我发起的(免费码)
    getPageByFreeCodeSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.freeCodeSponsoredPageNum;
      reqData.pageSize = this.freeCodeSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getOtherConfigApplyPage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if(v.status=='1'){
                v.statusText='申请中'
              }else if(v.status=='3'){
                v.statusText='已通过'
              }else if(v.status=='2'){
                v.statusText='已驳回'
              }else if(v.status=='4'){
                v.statusText='已撤回'
              }
            });
            this.freeCodeSponsoredTotal = res.data.data.total;
            this.freeCodeSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(免费码)
    getPageByFreeCodePendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.freeCodePendingApprovalPageNum;
      reqData.pageSize = this.freeCodePendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getOtherConfigApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            this.freeCodePendingApprovalTotal = res.data.data.total;
            this.freeCodePendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(免费码)
    getPageByFreeCodeApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.freeCodeApprovedPageNum;
      reqData.pageSize = this.freeCodeApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "1";
      this.$axios
        .post(api.getOtherConfigApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if(v.status=='0'){
                v.statusText='申请中'
              }else if(v.status=='1'){
                v.statusText='已通过'
              }else if(v.status=='2'){
                v.statusText='已驳回'
              }
            });
            this.freeCodeApprovedTotal = res.data.data.total;
            this.freeCodeApprovedTableData = data;
            console.log(this.freeCodeApprovedTableData);
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 免费码审批通过
    freeCodeApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.freeCodeApproveData = data;
      this.approveFreeCodeDialog = true;
    },
    // 免费码审批驳回
    freeCodeUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.freeCodeUnApproveData = data;
      this.approveFreeCodeRejectDialog = true;
    },

    // 取消通过
    cancelFreeCodeApprove() {
      this.freeCodeMemo = "";
      this.approveFreeCodeDialog = false;
    },

    // 确认通过
    passFreeCodeSubmit() {
      this.freeCodeApproveData.applyResult = this.applyResult;
      this.$axios
        .post(api.agreeAuthorizerApply, this.freeCodeApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.applyResult = "";
            this.approveFreeCodeDialog = false;
            nSuccess("审批已通过");
            this.getPageByFreeCodePendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    cancelFreeCodeReject() {
      this.freeCodeMemo = "";
      this.approveFreeCodeRejectDialog = false;
    },

    // 确认驳回
    unpassFreeCodeSubmit() {
      this.freeCodeUnApproveData.applyResult = this.applyResult;
      this.$axios
        .post(api.rejectAuthorizerApply, this.freeCodeUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.applyResult = "";
            this.approveFreeCodeRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByFreeCodePendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },

    //撤回
    recall(data){
      let reqData={};
      reqData.code=data.code
      reqData.applyRecordCode=data.applyRecordCode
      this.$axios.post(api.applyCallback,reqData).then(res=>{
        nSuccess("审批已驳回");
        this.getPageByFreeCodeSponsorAccountCode()
      }).catch(errorHandler("撤回失败"))
    },
    seeExample(data){
      if(!data.applyCode){
        data.applyCode=data.code
      }
      this.$axios.post(api.getApplyFlow, {applyCode: data.applyCode}).then(res=>{
        this.applyData=res.data.data.apply
        this.chainList=res.data.data.chainList
        this.flowData=res.data.data.flow.flowDetails
        if(this.applyData.status=='4'){
          this.flowDialog=true;
          this.currentRate=0
          return;
        }
        this.flowData.map(u=>{
          u.statusText=u.accountName
          this.chainList.map(v=>{
            if(v.approveAccountCode==u.accountCode){
              u.approveDate=v.approveDate
              u.status=v.status
              if(v.status=='1'){
                u.statusText=u.accountName+'已通过'
              } else if(v.status=='2'){
                u.statusText=u.accountName+'已驳回'
              }
            }
          })
        })
        this.flowData.map(v=>{
          let accountCode = v.accountCode;
          this.chainList.map(u=>{
            if(accountCode == u.approveAccountCode){
              if(u.approveStatus=='0'){
                this.currentRate =+ u.level;
              }else{
                this.currentRate =+ u.level+1;
              }
            }
          })
        })
        // this.flowData.map(v=>{
        //   if(v.accountCode==this.chainList[0].approveAccountCode){
        //     if(this.chainList[0].approveStatus=='0'){
        //       this.currentRate=+this.chainList[0].level
        //     }else{
        //       this.currentRate=+this.chainList[0].level+1
        //     }
        //   }
        // })
        this.flowDialog=true
      }).catch(errorHandler("获取审批进度失败"))
    }
  },
  watch: {
    freeCodeActiveName(val) {
      if (val === "freeCodeSponsored") {
        this.freeCodeSponsoredPageNum = 1;
        this.freeCodeSponsoredPageSize = 10;
        this.getPageByFreeCodeSponsorAccountCode();
      } else if (val === "freeCodePendingApproval") {
        this.freeCodePendingApprovalPageNum = 1;
        this.freeCodePendingApprovalPageSize = 10;
        this.getPageByFreeCodePendingApprovalPage();
      } else if (val === "freeCodeApproved") {
        this.freeCodeApprovedPageNum = 1;
        this.freeCodeApprovedPageSize = 10;
        this.getPageByFreeCodeApprovedPage();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
  /deep/ .el-step__description {
  margin-top: -8em ;
}
  /deep/ .el-dialog__body{
    padding:50px 0 ;
    color: #1362FF ;
  }
  /deep/.el-step__head.is-success{
  color: #1362FF ;
  border-color: #1362FF ;
  }
  /deep/.el-step__title.is-success{
    color: #1362FF ;
  }
  /deep/.el-step__description.is-success{
    color:#1362FF ;
  }
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/FreeCodeApproval/FreeCodeApproval.vue